/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_3_DetailInputs */

const en_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple years, including 2017/2018`)
};

const es_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varios años, incluido 2017/2018`)
};

const de_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Jahre, darunter 2017/2018`)
};

const zh_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多年，包括 2017/2018`)
};

const ar_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنوات متعددة، بما في ذلك 2017/2018`)
};

const fr_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs années, dont 2017/2018`)
};

const vi_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiều năm, gồm 2017/2018`)
};

const sw_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miaka kadhaa, ikiwemo 2017/2018`)
};

const th_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลายปี รวมถึงปี 2017/2018`)
};

const bs_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Više godina, uključujući 2017/2018`)
};

const ja_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数年（2017/2018年を含む）`)
};

const ko_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017/2018년을 포함한 여러 해`)
};

const pt_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vários anos, incluindo 2017/2018`)
};

const it_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più anni, tra cui 2017/2018`)
};

const sv_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flera år, inklusive 2017/2018`)
};

const nl_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meerdere jaren, waaronder 2017/2018`)
};

const da_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere år, herunder 2017/2018`)
};

const nb_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere år, inkludert 2017/2018`)
};

const fi_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Useita vuosia, mukaan lukien 2017/2018`)
};

const pl_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiele lat, w tym 2017/2018`)
};

const ru_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Несколько лет, включая 2017/2018`)
};

const tr_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2017/2018 dahil olmak üzere birçok yıl`)
};

const hi_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कई वर्ष, 2017/2018 सहित`)
};

const id_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beberapa tahun, termasuk 2017/2018`)
};

const ms_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beberapa tahun, termasuk 2017/2018`)
};

const cs_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Několik let, včetně 2017/2018`)
};

const el_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πολλά έτη, μεταξύ των οποίων το 2017/2018`)
};

const he_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר שנים, כולל 2017/2018`)
};

const af_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verskeie jare, insluitend 2017/2018`)
};

const hu_about_content_honor_1_item_3_detail = /** @type {(inputs: About_Content_Honor_1_Item_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Több évben, köztük 2017/2018-ban`)
};

/**
* | output |
* | --- |
* | "Multiple years, including 2017/2018" |
*
* @param {About_Content_Honor_1_Item_3_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_3_detail = /** @type {((inputs?: About_Content_Honor_1_Item_3_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_3_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_3_detail(inputs)
	if (locale === "de") return de_about_content_honor_1_item_3_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_3_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_3_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_3_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_3_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_3_detail(inputs)
	if (locale === "th") return th_about_content_honor_1_item_3_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_3_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_3_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_3_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_3_detail(inputs)
	if (locale === "it") return it_about_content_honor_1_item_3_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_3_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_3_detail(inputs)
	if (locale === "da") return da_about_content_honor_1_item_3_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_3_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_3_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_3_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_3_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_3_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_3_detail(inputs)
	if (locale === "id") return id_about_content_honor_1_item_3_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_3_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_3_detail(inputs)
	if (locale === "el") return el_about_content_honor_1_item_3_detail(inputs)
	if (locale === "he") return he_about_content_honor_1_item_3_detail(inputs)
	if (locale === "af") return af_about_content_honor_1_item_3_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_3_detail(inputs)
	return en_about_content_honor_1_item_3_detail(inputs)
});